var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("v-divider"),
      _c(
        "v-list",
        { attrs: { subheader: "", dense: "" } },
        [
          _c("v-subheader", [_vm._v(" Lobby Guests ")]),
          _vm._l(_vm.lobbyGuests, function (guest) {
            return _c(
              "v-list-item",
              { key: guest.presence_ref },
              [
                _c(
                  "v-list-item-avatar",
                  { attrs: { color: "secondary" } },
                  [
                    _c("v-icon", { attrs: { dark: "" } }, [
                      _vm._v("mdi-account-circle"),
                    ]),
                  ],
                  1
                ),
                _c(
                  "v-list-item-content",
                  [
                    _c("v-list-item-title", [
                      _vm._v(
                        _vm._s(
                          guest.guest_name != ""
                            ? `${guest.guest_name}`
                            : `Anonymous`
                        )
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "v-list-item-icon",
                  { staticClass: "pt-2" },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { "x-small": "", color: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.admit(guest)
                          },
                        },
                      },
                      [_vm._v("Admit")]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }